import React from 'react';

interface SurveyQuestionInterface {
    question: string;
    rating: number;
    setRating: any;
};

function SurveyQuestion({question, rating, setRating}: SurveyQuestionInterface) {

    const handleSetRating = (newRating: number) => {
        setRating(newRating);
    }

    return (
        <div className="surveyQuestionWrapper">
           <div className="surveyQuestionText">{question}</div>
           <div className="surveyQuestionButtonWrapper">
                <button className="surveyQuestionRatingButton"
                    style={{backgroundColor: `${rating === 1 ? "#D30000" : "#F2F2F2"}`}}
                    onClick={() => handleSetRating(1)}>1</button>
                <button className="surveyQuestionRatingButton"
                    style={{backgroundColor: `${rating === 2 ? "#D30000" : "#F2F2F2"}`}}
                    onClick={() => handleSetRating(2)}>2</button>
                <button className="surveyQuestionRatingButton"
                    style={{backgroundColor: `${rating === 3 ? "#D30000" : "#F2F2F2"}`}}
                    onClick={() => handleSetRating(3)}>3</button>
                <button className="surveyQuestionRatingButton"
                    style={{backgroundColor: `${rating === 4 ? "#D30000" : "#F2F2F2"}`}}
                    onClick={() => handleSetRating(4)}>4</button>
                <button className="surveyQuestionRatingButton"
                    style={{backgroundColor: `${rating === 5 ? "#D30000" : "#F2F2F2"}`}}
                    onClick={() => handleSetRating(5)}>5</button>
           </div>
        </div>
    );
};

export default SurveyQuestion;